import { appConfig } from '@/config/app.ts'

export interface MarketplaceState {
  isCreateModalOpen: boolean
  editId: number | null
  filters: string
}

export const initialState: MarketplaceState = {
  isCreateModalOpen: false,
  editId: null,
  filters: `?limit=${appConfig.pagination.defaultValue}`
}
